import { render, staticRenderFns } from "./SalesClientsStackedChart.vue?vue&type=template&id=1de4ff9a&scoped=true"
import script from "./SalesClientsStackedChart.vue?vue&type=script&lang=js"
export * from "./SalesClientsStackedChart.vue?vue&type=script&lang=js"
import style0 from "./SalesClientsStackedChart.vue?vue&type=style&index=0&id=1de4ff9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de4ff9a",
  null
  
)

export default component.exports